import Tasks from 'APP/Tasks';
import { IMessage } from 'APP/model/message/messageModel.types';

export async function handleUpdateMessages(messages: IMessage[]): Promise<void> {
  for (let i = 0; i < messages.length; i++) {
    const message = messages[i];
    await Tasks.relationships.loadUnknownDataFromMessages({
      messages: [message],
    });

    Tasks.messaging.updateOldOrFakeMessages({
      messages: [message],
      groupId: message.groupId,
    });

    //TODO: now we don't have counter info
    // if (data.threadCounter) {
    //   Tasks.group.addCounters([mapCounterResponse(data.threadCounter)]);
    // }
  }
}
